import { useEffect, useState } from 'react';
import { RuntimeBackendCard } from '../../features/runtime/RuntimeBackendCard';
import { getSupabaseRuntimeStatus } from '../../features/runtime/supabaseAdapter';
import type { RuntimeBackendStatus } from '../../features/runtime/types';

const bootstrapFile = 'database/v2/generated/DEV_BOOTSTRAP_ALL.sql';
const verifyFile = 'database/v2/generated/DEV_POST_APPLY_VERIFY.sql';

export function AdminDevSetupPage() {
  const [status, setStatus] = useState<RuntimeBackendStatus | null>(null);

  useEffect(() => {
    let mounted = true;
    void getSupabaseRuntimeStatus().then((next) => { if (mounted) setStatus(next); });
    return () => { mounted = false; };
  }, []);

  return (
    <div className="stack">
      <div>
        <div className="eyebrow">PILOT-01A · DEV Only</div>
        <h1>Supabase DEV Setup</h1>
        <p className="muted">Halaman diagnostik ini membantu verifikasi cloud tanpa menjadikan credential sebagai bagian dari source code.</p>
      </div>

      <section className="card">
        <h2>Urutan aman</h2>
        <ol className="setup-steps">
          <li><strong>Buat project Supabase DEV.</strong><span>Jangan gunakan project production untuk pilot pertama.</span></li>
          <li><strong>Jalankan satu bootstrap.</strong><code>{bootstrapFile}</code></li>
          <li><strong>Jalankan verifikasi.</strong><code>{verifyFile}</code></li>
          <li><strong>Pasang URL + publishable key di environment DEV.</strong><span>Secret/service-role key tidak boleh masuk browser.</span></li>
          <li><strong>Login sebagai user pilot.</strong><span>Fixture DEV tetap OFF sampai diaktifkan secara eksplisit.</span></li>
          <li><strong>Tekan “Periksa Supabase DEV”.</strong><span>Semua check harus PASS sebelum cloud sync pilot diaktifkan.</span></li>
        </ol>
      </section>

      <section className="grid grid--3">
        <div className="metric"><span>Konfigurasi</span><strong>{status?.configured ? 'Ada' : 'Belum'}</strong></div>
        <div className="metric"><span>Login</span><strong>{status?.authenticated ? 'Aktif' : 'Belum'}</strong></div>
        <div className="metric"><span>Realtime</span><strong>{status?.realtimeAvailable ? 'Siap uji' : 'Belum'}</strong></div>
      </section>

      <RuntimeBackendCard />

      <section className="card warning-card">
        <h2>Yang tidak boleh dilakukan</h2>
        <p>Jangan menaruh <strong>service_role key</strong>, password database, token pribadi, atau credential lain di file frontend, GitHub, screenshot, maupun chat. Browser hanya memakai publishable/anon key yang memang dirancang untuk client bersama RLS.</p>
      </section>
    </div>
  );
}
